import _toConsumableArray from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.replace-all.js";
import "core-js/modules/es.array.slice.js";
import { createDomainRR, deleteDomainRR as _deleteDomainRR, batchDeleteDomain, updateDomainRR, findDomainRR, getDomainRRList, updateDomainStatus } from "@/api/domain"; //  此处请自行替换地址
import { updateDomainRemark } from "@/api/domainIndex"; //  此处请自行替换地址
import { enableHealthCheck, disableHealthCheck } from "@/api/biz_hc";
import { formatTimeToStr } from "@/utils/date";
import infoList from "@/mixins/infoList";
import region from '@/view/zone/domain/region.vue';
import { store } from '@/store/index';
import { regionToView, viewToRegion, setSelectedNames } from '@/utils/viewinfo';
import { checkDomain, isIPv4, isIPv6 } from '@/utils/stringFun';
import HCharts from "@/components/hCharts";
export default {
  components: {
    region: region,
    HCharts: HCharts
  },
  name: "DomainList",
  mixins: [infoList],
  props: {
    qSearchInfo: {
      type: Object,
      require: true
    }
  },
  data: function data() {
    return {
      activeName: 'tab-recorder',
      listApi: getDomainRRList,
      dialogFormVisible: false,
      queryVisible: false,
      type: "",
      deleteVisible: false,
      multipleSelection: [],
      listAlias: 'domain',
      qZone: this.$route.query.zone,
      isDisabledSaveBtn: false,
      fullscreenLoading: false,
      formData: {
        name: "",
        status: true
      },
      cloneFormData: {
        name: ""
      },
      dbRecord: {},
      record: {
        default: {
          names: ["default"],
          labels: [this.$t('region.view-default')],
          targets: [{
            type: "",
            value: "",
            ttl: 600,
            // extend:10,
            weight: "",
            status: 0,
            priority: 0,
            isHc: true,
            valueTip: this.$t('region.dlg-input-value')
          }],
          hc: {
            tplName: '',
            tplId: 0,
            hcStatus: 0
          }
        },
        region: []
      },
      cloneDialogFormVisible: false,
      param: {},
      addRemarkDialogFormVisible: false,
      remarkFormData: {
        remark: ""
      },
      domainSeparator: '.',
      isPrimaryDomain: false,
      selectedPrimaryDomain: false,
      smartRecorderType: [{
        label: this.$t('region.recordtype-annotation-a'),
        value: 'A'
      }, {
        label: this.$t('region.recordtype-annotation-aaaa'),
        value: 'AAAA'
      }, {
        label: this.$t('region.recordtype-annotation-cname'),
        value: 'CNAME'
      }],
      defaultRecorderType: [],
      zoneStatus: 0,
      isPtrZone: this.$route.query.zone.endsWith('.in-addr.arpa') || this.$route.query.zone.endsWith('.ip6.arpa')
    };
  },
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time != "") {
        var date = new Date(time * 1000);
        return formatTimeToStr(date, "yyyy-MM-dd hh:mm:ss");
      } else {
        return "";
      }
    },
    formatDomain: function formatDomain(data) {
      if (data != "." && data.endsWith('.')) {
        return data.substring(0, data.length - 1);
      }
      return data;
    }
  },
  computed: {
    zoneName: function zoneName() {
      return this.domainSeparator + this.qZone;
    },
    zoneFqName: function zoneFqName() {
      return this.qZone + '.';
    }
  },
  methods: {
    goBack: function goBack() {
      this.$router.push({
        name: "zone"
      });
    },
    //条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      if (this.searchInfo.extend == "") {
        this.searchInfo.extend = null;
      }
      if (this.searchInfo.status == "") {
        this.searchInfo.status = null;
      }
      // this.searchInfo.zoneId=this.$route.query.zoneId
      this.getTableData();
    },
    domainStatusBtnTip: function domainStatusBtnTip(row) {
      var _tip = '';
      if (row.domain == this.zoneFqName) {
        _tip = this.$t('domain.domain-opt-status-primary');
      } else if (this.zoneStatus == 2) {
        _tip = this.$t('domain.domain-opt-status-zone');
      } else {
        _tip = row.status == 0 ? this.$t('domain.table-menu-domain-pause') : this.$t('domain.table-menu-domain-enable');
      }
      return _tip;
    },
    domainHcStatusBtnTip: function domainHcStatusBtnTip(row) {
      var _tip = '';
      if (row.status == 1) {
        _tip = this.$t('domain.domain-opt-hcstatus-domain');
      } else if (this.zoneStatus == 2) {
        _tip = this.$t('domain.domain-opt-hcstatus-zone');
      }
      return _tip;
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      // 选中主域名时，禁用批量删除按钮
      var ths = this;
      ths.selectedPrimaryDomain = false;
      val.forEach(function (v) {
        if (v.domain == ths.zoneFqName) {
          ths.selectedPrimaryDomain = true;
          return false;
        }
      });
    },
    getStatus: function getStatus(data) {
      if (data == -1) {
        return this.$t('domain.table-hc-notsetting');
      } else if (data == 1) {
        return this.$t('domain.table-hc-disable');
      } else {
        return this.$t('domain.table-hc-enable');
      }
    },
    formatStatus: function formatStatus(status) {
      var info = this.$t('domain.status-ok');
      if (status == 1) {
        info = this.$t('domain.status-pause');
      }
      return info;
    },
    changeType: function changeType() {
      if (this.isPrimaryDomain) {
        this.defaultRecorderType = [{
          label: this.$t('region.recordtype-annotation-a'),
          value: 'A'
        }, {
          label: this.$t('region.recordtype-annotation-aaaa'),
          value: 'AAAA'
        }, {
          label: this.$t('region.recordtype-annotation-mx'),
          value: 'MX'
        }, {
          label: this.$t('region.recordtype-annotation-txt'),
          value: 'TXT'
        }, {
          label: this.$t('region.recordtype-annotation-srv'),
          value: 'SRV'
        }, {
          label: this.$t('region.recordtype-annotation-caa'),
          value: 'CAA'
        }, {
          label: this.$t('region.recordtype-annotation-spf'),
          value: 'SPF'
        }, {
          label: this.$t('region.recordtype-annotation-naptr'),
          value: 'NAPTR'
        }];
      } else if (this.isPtrZone) {
        this.defaultRecorderType = [{
          label: this.$t('region.recordtype-annotation-ptr'),
          value: 'PTR'
        }, {
          label: this.$t('region.recordtype-annotation-ns'),
          value: 'NS'
        }];
      } else {
        this.defaultRecorderType = [{
          label: this.$t('region.recordtype-annotation-a'),
          value: 'A'
        }, {
          label: this.$t('region.recordtype-annotation-aaaa'),
          value: 'AAAA'
        }, {
          label: this.$t('region.recordtype-annotation-cname'),
          value: 'CNAME'
        }, {
          label: this.$t('region.recordtype-annotation-mx'),
          value: 'MX'
        }, {
          label: this.$t('region.recordtype-annotation-txt'),
          value: 'TXT'
        }, {
          label: this.$t('region.recordtype-annotation-ns'),
          value: 'NS'
        }, {
          label: this.$t('region.recordtype-annotation-srv'),
          value: 'SRV'
        }, {
          label: this.$t('region.recordtype-annotation-caa'),
          value: 'CAA'
        }, {
          label: this.$t('region.recordtype-annotation-spf'),
          value: 'SPF'
        }, {
          label: this.$t('region.recordtype-annotation-naptr'),
          value: 'NAPTR'
        }];
      }
    },
    chopSuffix: function chopSuffix(data) {
      if (data != "." && data.endsWith('.')) {
        return data.substring(0, data.length - 1);
      }
      return data;
    },
    deleteRow: function deleteRow(row) {
      var _this = this;
      this.$confirm(this.$t('common.button.delete') + ' ' + this.chopSuffix(row.domain) + '?', this.$t('common.msg.prompt-title'), {
        confirmButtonText: this.$t('common.button.yes'),
        cancelButtonText: this.$t('common.button.no'),
        type: 'warning'
      }).then(function () {
        _this.deleteDomainRR(row);
      });
    },
    cloneRow: function cloneRow(row) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return findDomainRR({
                domain: row.domain,
                zone: _this2.$route.query.zone
              });
            case 2:
              res = _context.sent;
              if (!(res.code != 0)) {
                _context.next = 6;
                break;
              }
              _this2.$message({
                type: "error",
                message: _this2.$t('common.msg.opt-failed')
              });
              return _context.abrupt("return");
            case 6:
              _this2.dbRecord = res.data.record;
              _this2.cloneDialogFormVisible = true;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    closeCloneDialog: function closeCloneDialog() {
      this.cloneDialogFormVisible = false;
      this.$refs['cloneFormData'].resetFields();
    },
    saveCloneDialog: function saveCloneDialog(formName) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var isOk, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // 校验表单
              isOk = true;
              _this3.$refs[formName].validate(function (valid) {
                if (!valid) {
                  isOk = false;
                  return false;
                }
              });
              if (isOk) {
                _context2.next = 4;
                break;
              }
              return _context2.abrupt("return", false);
            case 4:
              _this3.dbRecord['zone'] = _this3.$route.query.zone;
              _this3.dbRecord['name'] = _this3.cloneFormData.name + '.' + _this3.$route.query.zone;
              _this3.fullscreenLoading = true;
              _context2.next = 9;
              return createDomainRR(_this3.dbRecord);
            case 9:
              res = _context2.sent;
              if (res.code == 0) {
                _this3.$message({
                  type: "success",
                  message: _this3.$t('domain.clone-success')
                });
                _this3.closeCloneDialog();
                _this3.getTableData();
                _this3.fullscreenLoading = false;
              } else {
                _this3.isDisabledSaveBtn = false;
                _this3.fullscreenLoading = false;
              }
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    addRegion: function addRegion() {
      this.record.region.push({
        names: [],
        labels: [],
        lines: [],
        targets: [{
          type: '',
          value: '',
          ttl: 600,
          // extend: 10,
          weight: '',
          status: 0,
          priority: 0,
          isHc: true,
          valueTip: this.$t('region.dlg-input-value')
        }],
        hc: {
          tplName: '',
          tplId: 0,
          hcStatus: 0
        }
      });
    },
    delRegion: function delRegion(index) {
      setSelectedNames([], this.record.region[index].names);
      this.record.region.splice(index, 1);
    },
    onDelete: function onDelete() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var domains;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              domains = [];
              if (!(_this4.multipleSelection.length == 0)) {
                _context4.next = 4;
                break;
              }
              _this4.$message({
                type: 'warning',
                message: _this4.$t('common.msg.delete-choose-warn')
              });
              return _context4.abrupt("return");
            case 4:
              _this4.multipleSelection && _this4.multipleSelection.map(function (item) {
                domains.push({
                  name: item.domain,
                  zone: _this4.$route.query.zone
                });
              });
              _this4.$confirm(_this4.$t('common.msg.delete-prompt-info'), _this4.$t('common.msg.prompt-title'), {
                confirmButtonText: _this4.$t('common.button.yes'),
                cancelButtonText: _this4.$t('common.button.no'),
                type: 'warning'
              }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
                var res;
                return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.next = 2;
                      return batchDeleteDomain(domains, _this4.$route.query.zone);
                    case 2:
                      res = _context3.sent;
                      if (res.code == 0) {
                        _this4.$message({
                          type: 'success',
                          message: _this4.$t('common.msg.delete-success')
                        });
                        if (_this4.tableData.length == domains.length) {
                          _this4.page--;
                        }
                        _this4.deleteVisible = false;
                        _this4.getTableData();
                      }
                    case 4:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              })));
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    updateDomainRR: function updateDomainRR(row) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var listName, res, data;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              listName = _this5.listAlias;
              _context5.next = 3;
              return findDomainRR({
                domain: row.domain,
                zone: _this5.$route.query.zone
              });
            case 3:
              res = _context5.sent;
              _context5.next = 6;
              return store.dispatch('viewinfo/clearSelectedNames');
            case 6:
              _this5.type = "update";
              if (res.code == 0) {
                data = res.data[listName][0];
                _this5.formData.name = data.domain.replace('.' + _this5.$route.query.zone + '.', '');
                _this5.formData.status = data.status == 0;
                if (_this5.formData.name == _this5.zoneFqName) {
                  _this5.formData.name = ' ';
                  _this5.domainSeparator = '';
                  _this5.isPrimaryDomain = true;
                }
                _this5.record = viewToRegion(res.data.record, _this5.$route.query.zone);
                _this5.dialogFormVisible = true;
              }
              _this5.changeType();
            case 9:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    closeDialog: function closeDialog() {
      this.dialogFormVisible = false;
      this.isDisabledSaveBtn = false;
      this.formData.name = "";
      this.formData.status = true;
      this.record = {
        default: {
          names: ["default"],
          labels: [this.$t('region.view-default')],
          targets: [{
            type: "",
            value: "",
            ttl: 600,
            // extend:10,
            weight: "",
            status: 0,
            priority: 0,
            isHc: true,
            valueTip: this.$t('region.dlg-input-value')
          }],
          hc: {
            tplName: '',
            tplId: 0,
            hcStatus: 0
          }
        },
        region: []
      };
      this.domainSeparator = '.';
      this.isPrimaryDomain = false;
      this.$refs['formData'].resetFields();
    },
    openQueryDialog: function openQueryDialog(row) {
      this.queryVisible = true;
      this.param = {
        zone: this.$route.query.zone,
        domain: row.domain,
        showTop: false
      };
    },
    closeQueryDialog: function closeQueryDialog() {
      this.queryVisible = false;
    },
    deleteDomainRR: function deleteDomainRR(row) {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var res;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _deleteDomainRR({
                domain: row.domain,
                zone: _this6.$route.query.zone
              });
            case 2:
              res = _context6.sent;
              if (res.code == 0) {
                _this6.$message({
                  type: "success",
                  message: _this6.$t('common.msg.delete-success')
                });
                if (_this6.tableData.length == 1) {
                  _this6.page--;
                }
                _this6.getTableData();
              }
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    validateRegion: function validateRegion(region) {
      var _this7 = this;
      var err = [];
      if (!region.names || region.names.length == 0) {
        err.push(this.$t('domain.validate-no-region'));
      }
      var _typeMap = new Map();
      var valueMap = new Map();
      var masterRecCount = 0;
      var hasHcRecord = false;
      region.targets.forEach(function (target) {
        target.priority = target.priority || 0;
        var priorityDes = '';
        if (region.hc.tplName != '') {
          priorityDes = target.priority == 1 ? '备' : '主';
        }
        if (!_typeMap.has(target.priority)) {
          _typeMap.set(target.priority, target.type);
        }
        if (target.value == '') {
          err.push(_this7.$t('domain.validate-no-value'));
          return true;
        }
        if (valueMap.has(target.value) && valueMap.get(target.value) == target.type) {
          err.push(_this7.$t('domain.validate-exists-value'));
          return true;
        }
        valueMap.set(target.value, target.type);

        // 主记录
        if (target.priority == 0) {
          masterRecCount++;
        }
        if (target.isHc) {
          hasHcRecord = true;
        }
        if (target.ttl < 60 || target.ttl > 604800) {
          err.push(_this7.$t('domain.validate-ttl-scope'));
        }
        if (target.type == '') {
          err.push(_this7.$t('domain.validate-no-type'));
        } else if (target.type == 'CNAME') {
          // 判断域名是否正确
          if (!checkDomain(target.value) || isIPv4(target.value)) {
            err.push(target.type + _this7.$t('domain.validate-invalid-value'));
          }

          // 判断类型并存
          if (_typeMap.get(target.priority) != target.type) {
            err.push(_this7.$t('domain.validate-coexist-region') + priorityDes + '，' + target.type + _this7.$t('domain.validate-coexist-type'));
          }
        } else if (target.type == 'NS') {
          // 判断域名是否正确
          if (!checkDomain(target.value) || isIPv4(target.value)) {
            err.push(target.type + _this7.$t('domain.validate-invalid-value'));
          }

          // 判断类型并存
          if (!_this7.isPrimaryDomain && _typeMap.get(target.priority) != target.type) {
            err.push(_this7.$t('domain.validate-coexist-region') + priorityDes + '，' + target.type + _this7.$t('domain.validate-coexist-type'));
          }
        } else {
          if (target.type == 'A') {
            // 判断ip是否正确
            if (!isIPv4(target.value)) {
              err.push(target.type + _this7.$t('domain.validate-invalid-value'));
            }
            if (target.weight < 0 || target.weight > 10) {
              err.push(_this7.$t('domain.validate-weight-scope'));
            }
          } else if (target.type == 'AAAA') {
            // 判断ip是否正确
            if (!isIPv6(target.value)) {
              err.push(target.type + _this7.$t('domain.validate-invalid-value'));
            }
          } else if (target.type == 'PTR') {
            // 判断ip是否正确
            if (!checkDomain(target.value) || isIPv4(target.value)) {
              err.push(target.type + _this7.$t('domain.validate-invalid-value'));
            }
          }
          // 判断类型并存
          if (_typeMap.get(target.priority) == 'CNAME') {
            err.push(_this7.$t('domain.validate-coexist-region') + priorityDes + '，' + target.type + _this7.$t('domain.validate-coexist-cname'));
          }
          if (!_this7.isPrimaryDomain && _typeMap.get(target.priority) == 'NS') {
            err.push(_this7.$t('domain.validate-coexist-region') + priorityDes + '，' + target.type + _this7.$t('domain.validate-coexist-ns'));
          }
        }
      });
      if (region.hc.tplName != '' && masterRecCount == 0) {
        err.push(this.$t('domain.validate-no-master'));
      }
      if (region.hc.tplName != '' && !hasHcRecord) {
        err.push(this.$t('domain.validate-no-hc'));
      }
      return err;
    },
    validateForm: function validateForm() {
      var _this8 = this;
      var err = this.validateRegion(this.record.default);
      if (this.record.region) {
        this.record.region.forEach(function (record) {
          var smartErr = _this8.validateRegion(record);
          err = [].concat(_toConsumableArray(err), _toConsumableArray(smartErr));
        });
      }
      return err;
    },
    enterDialog: function enterDialog(formName) {
      var _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var isOk, err, msgArr, viewObj, res;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              // 校验表单
              isOk = true;
              _this9.$refs[formName].validate(function (valid) {
                if (!valid) {
                  isOk = false;
                  return false;
                }
              });
              if (isOk) {
                _context7.next = 4;
                break;
              }
              return _context7.abrupt("return", false);
            case 4:
              err = _this9.validateForm();
              if (!(err.length > 0)) {
                _context7.next = 10;
                break;
              }
              msgArr = [];
              err.forEach(function (val) {
                msgArr.push('<li style="margin: 5px 0;">' + val + '</li>');
              });
              _this9.$message({
                type: 'error',
                showClose: true,
                dangerouslyUseHTMLString: true,
                message: '<ul>' + msgArr.join("") + '</ul>'
              });
              return _context7.abrupt("return", false);
            case 10:
              _this9.isDisabledSaveBtn = true;
              viewObj = regionToView(_this9.record, _this9.isPrimaryDomain);
              viewObj['zone'] = _this9.$route.query.zone;
              if (_this9.isPrimaryDomain) {
                viewObj['name'] = _this9.$route.query.zone;
              } else {
                viewObj['name'] = _this9.formData.name + '.' + _this9.$route.query.zone;
              }
              viewObj['pause'] = !_this9.formData.status;
              _this9.fullscreenLoading = true;
              _context7.t0 = _this9.type;
              _context7.next = _context7.t0 === "create" ? 19 : _context7.t0 === "update" ? 23 : 27;
              break;
            case 19:
              _context7.next = 21;
              return createDomainRR(viewObj);
            case 21:
              res = _context7.sent;
              return _context7.abrupt("break", 31);
            case 23:
              _context7.next = 25;
              return updateDomainRR(viewObj);
            case 25:
              res = _context7.sent;
              return _context7.abrupt("break", 31);
            case 27:
              _context7.next = 29;
              return createDomainRR(viewObj);
            case 29:
              res = _context7.sent;
              return _context7.abrupt("break", 31);
            case 31:
              if (res.code == 0) {
                _this9.$message({
                  type: "success",
                  message: _this9.$t('common.msg.save-success')
                });
                _this9.closeDialog();
                _this9.getTableData();
                _this9.fullscreenLoading = false;
              } else {
                _this9.isDisabledSaveBtn = false;
                _this9.fullscreenLoading = false;
              }
            case 32:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    openDialog: function openDialog() {
      var _this10 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this10.type = "create";
              _context8.next = 3;
              return store.dispatch('viewinfo/clearSelectedNames');
            case 3:
              _this10.formData.name = "";
              _this10.dialogFormVisible = true;
              _this10.changeType();
            case 6:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    addRemark: function addRemark(row) {
      this.remarkFormData.dname = row.domain;
      this.remarkFormData.remark = row.remark;
      this.addRemarkDialogFormVisible = true;
    },
    closeAddRemarkDialog: function closeAddRemarkDialog() {
      this.addRemarkDialogFormVisible = false;
    },
    saveAddRemarkDialog: function saveAddRemarkDialog() {
      var _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var res;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return updateDomainRemark(_this11.remarkFormData);
            case 2:
              res = _context9.sent;
              if (res.code == 0) {
                _this11.$message({
                  type: "success",
                  message: _this11.$t('common.msg.opt-success')
                });
                _this11.closeAddRemarkDialog();
                _this11.getTableData();
                _this11.fullscreenLoading = false;
              } else {
                _this11.isDisabledSaveBtn = false;
                _this11.fullscreenLoading = false;
              }
            case 4:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    wrapCommandData: function wrapCommandData(flag, row) {
      return {
        flag: flag,
        row: row
      };
    },
    handleMenuCommand: function handleMenuCommand(_ref2) {
      var _this12 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var flag, row, res;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              flag = _ref2.flag, row = _ref2.row;
              if (!row) {
                _context10.next = 20;
                break;
              }
              if (!(flag == 'hc')) {
                _context10.next = 15;
                break;
              }
              if (!(row.hc_status == 0)) {
                _context10.next = 9;
                break;
              }
              _context10.next = 6;
              return disableHealthCheck({
                domain: row.domain
              });
            case 6:
              res = _context10.sent;
              _context10.next = 13;
              break;
            case 9:
              if (!(row.hc_status == 1)) {
                _context10.next = 13;
                break;
              }
              _context10.next = 12;
              return enableHealthCheck({
                domain: row.domain
              });
            case 12:
              res = _context10.sent;
            case 13:
              _context10.next = 19;
              break;
            case 15:
              if (!(flag == 'status')) {
                _context10.next = 19;
                break;
              }
              _context10.next = 18;
              return updateDomainStatus({
                zone: _this12.$route.query.zone,
                domain: row.domain,
                status: row.status != 0
              });
            case 18:
              res = _context10.sent;
            case 19:
              if (res && res.code == 0) {
                _this12.$message({
                  type: "success",
                  message: _this12.$t('common.msg.opt-success')
                });
                _this12.getTableData();
              }
            case 20:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    showHcTask: function showHcTask(row) {
      this.$router.push({
        name: "hcTask",
        query: {
          domain: row.domain
        }
      });
    },
    validateDomain: function validateDomain(rule, value, callback) {
      var reg = /^(?=^.{0,228}$)[a-zA-Z0-9_*\s][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9_][-a-zA-Z0-9]{0,62})*$/;
      if (value === '') {
        callback(new Error(this.$t('domain.checkdomain-error-empty')));
      } else if (!reg.test(value + this.zoneName)) {
        callback(new Error(this.$t('domain.checkdomain-error-invalid')));
      } else {
        // if(this.isPtrZone){
        //   const domainName = value  + '.' + this.zoneFqName
        //   const domain_ip = this.getReverseIP(domainName)
        //   console.log(domain_ip)
        //   if(!isIPv4(domain_ip) && !isIPv6(domain_ip)){
        //     callback(new Error(this.$t('domain.checkdomain-error-invalid')));
        //     return
        //   }
        // }
        callback();
      }
    },
    getReverseIP: function getReverseIP(domainName) {
      var domain_ip = '';
      if (domainName.endsWith('.in-addr.arpa') || domainName.endsWith('.in-addr.arpa.')) {
        domain_ip = this.chopSuffix(domainName).replaceAll('.in-addr.arpa', '');
        domain_ip = domain_ip.split('.').reverse().join('.');
      } else if (domainName.endsWith('.ip6.arpa') || domainName.endsWith('.ip6.arpa.')) {
        domain_ip = this.chopSuffix(domainName).replaceAll('.ip6.arpa', '');
        var domain_ip_arr = domain_ip.split('.');

        // 32位
        if (domain_ip_arr.length != 32) {
          return '';
        }

        // 每个只能是一个字母或数字
        var everyOnlyOne = domain_ip_arr.every(function (item) {
          return item.length == 1;
        });
        if (!everyOnlyOne) {
          return '';
        }

        // 每4个一组，用 : 隔开
        domain_ip = domain_ip_arr.reverse().join('');
        var new_ip_arr = [];
        var idx = 0;
        while (idx < domain_ip.length) {
          var _end = idx + 4;
          new_ip_arr.push(domain_ip.slice(idx, _end));
          idx = _end;
        }
        domain_ip = new_ip_arr.join(':');
      }
      return domain_ip;
    }
  },
  created: function created() {
    var _this13 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            // this.searchInfo.zone = this.$route.query.zone
            // if(this.$route.query.domain){
            //   this.$set(this.searchInfo, 'domain', this.$route.query.domain)
            //   this.$set(this.searchInfo, 'searchMode', 1)
            //   // this.searchInfo.domain = this.$route.query.domain
            //   // this.updateDomainRR({domain: this.$route.query.domain})
            // }
            _this13.searchInfo = _this13.qSearchInfo;

            // 获取模板
            Promise.all([_this13.getTableData(), store.dispatch('viewinfo/getTplMap'), store.dispatch('viewinfo/getRecordLines', _this13.$route.query.zone)]).then(function () {
              var _this13$qData$zone$;
              _this13.zoneStatus = ((_this13$qData$zone$ = _this13.qData.zone[0]) === null || _this13$qData$zone$ === void 0 ? void 0 : _this13$qData$zone$.status) || 0;
            }).catch(function (error) {
              console.log(error);
            });
          case 2:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }))();
  }
};